/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  event_id?: string;
  host_id?: string;
}
/**
 * 后端灰度开启开关列表（比如草稿箱列表传"list_draft"、创建活动传"create_event"）
 */
export type GraySwitch = string[];
export interface PublicSwitchEventGrayRes {
  data: Data;
  msg: string;
  code: number;
  nonce: string;
}
export interface Data {
  gray_switch: GraySwitch;
}

const PublicSwitchEventGray = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<PublicSwitchEventGrayRes>(
    '/wemeet-tapi',
    '/v2/activities/public/switch/event-gray',
    data,
    ctx,
  );

  return res;
};

export default PublicSwitchEventGray;
